import { useState } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import { UiKitCollapseBase } from '@/fo/ui/kit/collapse/base';
import { UiKitToggleBase } from '@/fo/ui/kit/toggle/base';

import { FilterOption } from '../../../types';
import { FilterComponentProps } from '../types';

import { styles } from './ToggleListFilter.styles';

/** Компонент для отображения toggle фильтров */
export function ToggleListFilter({
  options,
  selected,
  onChange,
  label,
  disabled
}: FilterComponentProps & { label?: string }) {
  const [collapse, setCollapse] = useState(true);
  const slots = styles({ collapse });

  return (
    <div className={slots.base()}>
      <div
        className={slots.header()}
        onClick={() => setCollapse((s) => !s)}
      >
        <div className={slots.label()}>{label}</div>
        <ChevronIcon className={slots.chevron()} />
      </div>

      <UiKitCollapseBase
        collapse={collapse}
        className={slots.collapse()}
      >
        <div className={slots.options()}>
          {(options as FilterOption[]).map((option) => {
            const isSelected =
              Array.isArray(selected) &&
              selected.some((value) => value === option.value);
            return (
              <UiKitToggleBase
                key={option.value}
                label={option.label}
                checked={isSelected}
                disabled={disabled}
                onChange={(checked) => onChange(option.value, checked)}
              />
            );
          })}
        </div>
      </UiKitCollapseBase>
    </div>
  );
}
